import axios from 'axios';

// Dedicated axios instance for Attendance endpoints.
const attendanceApi = axios.create({ baseURL: '/api/attendance', withCredentials: true });

attendanceApi.interceptors.request.use(cfg => {
  const token = localStorage.getItem('flowup_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

attendanceApi.interceptors.response.use(
  res => res.data,
  err => {
    if (err.response?.status === 401) {
      const onLogin = window.location.pathname === '/login';
      if (!onLogin) {
        localStorage.removeItem('flowup_token');
        window.dispatchEvent(new CustomEvent('auth:logout'));
        setTimeout(() => { window.location.replace('/login'); }, 100);
      }
    }
    return Promise.reject(err.response?.data || { error: err.message });
  }
);

attendanceApi.get = (url, config) => attendanceApi({ method: 'get', url, ...config });
attendanceApi.post = (url, data, config) => attendanceApi({ method: 'post', url, data, ...config });
attendanceApi.put = (url, data, config) => attendanceApi({ method: 'put', url, data, ...config });
attendanceApi.delete = (url, config) => attendanceApi({ method: 'delete', url, ...config });

export default attendanceApi;
